import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

interface DetailsPanelContextType {
  isOpen: boolean;
  close: () => void;
  open: () => void;
}

const DetailsPanelContext = createContext<DetailsPanelContextType | undefined>(undefined);

export const useDetailsPanel = () => {
  const context = useContext(DetailsPanelContext);
  if (context === undefined) {
    throw new Error('useDetailsPanel must be used within a DetailsPanelProvider');
  }
  return context;
};

export const DetailsPanelProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const value = useMemo(() => ({ isOpen, close, open }), [isOpen, close, open]);

  return <DetailsPanelContext.Provider value={value}>{children}</DetailsPanelContext.Provider>;
};
